import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureAmplify } from './lib/amplify';
import './index.css';

// Configure Amplify before anything else renders
configureAmplify();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Fade out the boot splash once React has painted the first frame.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById('boot-splash');
    if (!splash) return;
    splash.classList.add('boot-hide');
    splash.addEventListener('transitionend', () => splash.remove(), { once: true });
  });
});
